import linkState from './linkState';
import emailCollectionState from './emailCollectionState';
import dynamicFormState from './dynamicFormState';

const ctaState = {
  data: {
    [emailCollectionState.actionData.actionType]: emailCollectionState,
    [linkState.actionData.actionType]: linkState,
    [dynamicFormState.actionData.actionType]: dynamicFormState,
  },
  etc: {
    ctaType: '',
    ctaStep: 0,
    isCtaSubmittable: false,
    localBgData: {
      localUploadImage: '',
      color: '',
      url: '',
      images: [],
    },
    creationType: '',
    dynamicFields: 0,
  },
};
export default ctaState;
